module.exports = __webpack_public_path__ + "static/img/nodata.d6b285a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata.png
// module id = f0hK
// module chunks = 73